import { Typography } from '@mui/material';
import { useState, useEffect } from 'react';

interface IFHTimerProp {
  duration: number; // duration in seconds
  sx?: object;
  onTimerComplete?: () => void;
}

const FHTimer = ({ duration, onTimerComplete = () => {}, sx = {} }: IFHTimerProp) => {
  const [time, setTime] = useState(duration);

  useEffect(() => {
    if (!duration) return;
    setTime(duration);
    const timer = setInterval(() => {
      setTime((prevTime) => prevTime - 1);
    }, 1000); // set 1 second interval

    return () => clearInterval(timer);
  }, [duration]);

  useEffect(() => {
    if (time < 1) {
      onTimerComplete();
    }
  }, [time]);

  // Format the time to display it nicely
  const formattedTime = () => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  return <Typography sx={{ ...sx }}>{formattedTime()}</Typography>;
};

export default FHTimer;
